import { Box, Checkbox, FormControlLabel, Link } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import cssVars from '../../styles/vars.module.scss'
import { useTheme } from "@mui/material";

const PrivacyFiled = ({ checked, onChange = () => { }, formCheck, forGuest = false }) => {
    const { t } = useTranslation()
    const theme = useTheme()

    return (
        <FormControlLabel
            id='agree'

            sx={{
                'span:last-child': {
                    fontFamily: "inherit"
                }
            }}

            label={
                <Box fontSize={13}>
                    {t('By selecting ' + (forGuest ? '"Continue"' : '"Create account"') + ', you are confirming that you have read and agree to Bugnard ')}
                    <Link href="#" style={{ textDecoration: "underline", color: cssVars.black }}>{t('Terms of Use ')}</Link>
                    <Box component="span" mx={.5}>{t("and")}</Box>
                    <Link href="#" style={{ textDecoration: "underline", color: cssVars.black }}>{t('Privacy Policy')}</Link>
                </Box>
            }
            control={
                <Checkbox
                    sx={{ color: formCheck && !checked ? cssVars.red : cssVars.darkGray,mt:-1}}
                    checked={checked}
                    onChange={(e) => { onChange(e) }}
                />
            }
        />
    );
}

export default PrivacyFiled;